import { CustomerAppointmentDTO } from '../../api/api';
import { AppointmentErrors, BaseErrors } from '../../models/CreationErrors';
import { TaskCreationTask } from '../../models/TaskCreationTask';
import { validateCustomerAppointmentContact } from './customerAppointmentValidation';

export const validateBaseFields = (task: TaskCreationTask): BaseErrors => {
  let errors: BaseErrors = { taskLocation: false, earliestStartDate: false };

  if (!task.normTimeMin) errors.normTimeMin = true;

  if (!task.earliestStartDate) errors.earliestStartDate = true;

  if (!task.deadline) errors.deadline = true;

  if (!task.assignedToDepartmentId) errors.assignedToDepartmentId = true;

  if (!task.projectNumber) errors.projectNumber = true;

  if (!task.description) errors.description = true;

  if (!task.normTimeValidated) errors.normTimeValidated = true;

  if (!task.taskLocation && !task.assetLocation) errors.taskLocation = true;

  if (!task.taskTypeId) errors.taskTypeId = true;

  if (task.taskType?.emergencyOperationalFailure && !task.alarmType) errors.alarmType = true;

  if (task.taskType?.isPreparationTask) {
    if (!task.parentId) errors.parentId = true;

    if (isPreparationDayWindowRequired(task)) {
      const minDays = task.minTimeBeforeMainTaskDays;
      const maxDays = task.maxTimeBeforeMainTaskDays;
      const taskTypeMinDays = task.taskType.minTimeBeforeMainTaskDays;
      const taskTypeMaxDays = task.taskType.maxTimeBeforeMainTaskDays;

      const hasValidMinDays = isWholeDaysWithin(minDays, taskTypeMinDays, taskTypeMaxDays);
      const hasValidMaxDays = isWholeDaysWithin(maxDays, taskTypeMinDays, taskTypeMaxDays);

      const minIsGreaterThanMax = minDays != null && maxDays != null && minDays > maxDays;

      if (!hasValidMinDays || minIsGreaterThanMax) errors.minTimeBeforeMainTaskDays = true;
      if (!hasValidMaxDays || minIsGreaterThanMax) errors.maxTimeBeforeMainTaskDays = true;
    }
  }

  return errors;
};

const isWholeDaysWithin = (days?: number | null, lowerBound?: number | null, upperBound?: number | null) =>
  days != null &&
  Number.isInteger(days) &&
  days >= 0 &&
  (lowerBound == null || days >= lowerBound) &&
  (upperBound == null || days <= upperBound);

// A preparation task type without a day window (one not tied to a main task type) leaves the days
// optional on the task, but a window that is started must be filled in completely.
const isPreparationDayWindowRequired = (task: TaskCreationTask) =>
  task.taskType?.minTimeBeforeMainTaskDays != null ||
  task.taskType?.maxTimeBeforeMainTaskDays != null ||
  task.minTimeBeforeMainTaskDays != null ||
  task.maxTimeBeforeMainTaskDays != null;

export const validateMassCreationBaseFields = (task: TaskCreationTask): BaseErrors => {
  let errors: BaseErrors = { taskLocation: false, earliestStartDate: false };

  if (!task.normTimeMin) errors.normTimeMin = true;

  if (!task.earliestStartDate) errors.earliestStartDate = true;

  if (!task.deadline) errors.deadline = true;

  if (!task.assignedToDepartmentId) errors.assignedToDepartmentId = true;

  if (!task.projectNumber) errors.projectNumber = true;

  if (!task.normTimeValidated) errors.normTimeValidated = true;

  if (!task.taskTypeId) errors.taskTypeId = true;

  return errors;
};

export const validateCustomerAppointment = (customerAppointment?: CustomerAppointmentDTO): AppointmentErrors =>
  validateCustomerAppointmentContact(customerAppointment);
